var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import ApiRequests from "../../../classes/http/ApiRequests";
import HttpRequests from "../../../classes/http/HttpRequests";
import Grid from '../../../components/UI/Grid/Grid';
import AppRoutes from '../../../config/appRoutes';
var ProductLinesList = /** @class */ (function (_super) {
    __extends(ProductLinesList, _super);
    function ProductLinesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.staticPageId = '';
        _this.brandId = '';
        _this.gridHeaders = [
            { name: 'Име', key: 'bg_name', filter: false, sort: false },
            { name: 'Позиция', key: 'position', filter: false, sort: false }
        ];
        _this.editRegion = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                _this.props.history.push(AppRoutes.brand.path + '/' + _this.brandId +
                    AppRoutes.staticPage.path + '/' + _this.staticPageId +
                    AppRoutes.editProductLine.path.replace(':productLineId', selectedId));
            }
        };
        _this.deleteProductLine = function (rowItem) {
            var isStaticPageOnly = _this.staticPageId !== "-1" && _this.brandId === "-1";
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u0430?");
            if (ask) {
                var action = isStaticPageOnly ? _this.api.deleteStaticProductLine(_this.staticPageId, selectedId) : _this.api.deleteProductLine(selectedId);
                action
                    .then(function (response) {
                    // Delete the item from the state of the parent component
                    _this.props.deleteItem(selectedId);
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.props.messages, 'Записът не бе изтрит. Моля, опитайте отново.', _this.props.history);
                });
            }
        };
        return _this;
    }
    ProductLinesList.prototype.componentDidMount = function () {
        this.staticPageId = _.get(this.props, 'match.params.staticPageId', '-1');
        this.brandId = _.get(this.props, 'match.params.brandId', '-1');
    };
    ProductLinesList.prototype.render = function () {
        var gridData = this.props.gridData;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: '', paginator: true, total: 50, rows: 10, editAction: this.editRegion, deleteAction: this.deleteProductLine }));
    };
    return ProductLinesList;
}(React.Component));
// @ts-ignore
export default withRouter(ProductLinesList);



//////////////////
// WEBPACK FOOTER
// ./src/components/ProductLines/ProductLinesList/ProductLinesList.tsx
// module id = 523
// module chunks = 0